import React, {Component} from 'react'
import {Select} from 'antd'
import {compose} from 'recompose'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'
import CustomSelect from '../CustomSelect'

/*const Option = Select.Option*/

class ContractType extends Component {
  render() {
    const {data} = this.props
    const list = data['type'] || []
    return (
      <CustomSelect
        {...this.props}
        placeholder={'Select a Contract type'}
        data={list}
        keyAtr={'key'}
        valueAtr={'value'}
      />
    )
  }
}

// render() {
// const {value, onChange, placeholder, data} = this.props
// const list = data['type'] || []
// return (
//   <CustomSelect
//     value={value}
//     showSearch
//     onChange={onChange}
//     placeholder={placeholder || 'Select a Contract Type'}
//     keyAtr={'key'}
//     valueAtr={'value'}
//   filterOption={(input, option) =>
//     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//   }>
//   {list.map(c => <Option value={c.key}>{c.value}</Option>)}
// </CustomSelect>
// />
// )
// }
// }

const ContractTypeSelect = compose(
  withSelectFetch({dropdown: 'supplier', name: 'contract'}),
  withSpinning,
  withSort,
)(ContractType)

export default ContractTypeSelect
